import { W, wrap, fit, startCanvas, finishCanvas, loadSilks, drawSilk, ShareButtons } from "@/components/ShareButtons";
import { raceMs, clock12 } from "@/lib/raceFormat";

async function drawCard({ meeting, race }) {
  const { c, ctx } = await startCanvas(W);
  ctx.fillStyle = "#60a5fa"; ctx.font = "700 30px 'DM Sans', sans-serif";
  ctx.fillText(`${(meeting.state || "").toUpperCase()} · ${meeting.date}${race.start_time ? ` · ${clock12(raceMs(race, meeting.date))} AEST` : ""}`, 72, 340);
  ctx.fillStyle = "#ffffff"; ctx.font = "900 78px Outfit, sans-serif";
  ctx.fillText(`${meeting.track.toUpperCase()} R${race.number}`, 72, 430);
  ctx.fillStyle = "#94a3b8"; ctx.font = "500 32px 'DM Sans', sans-serif";
  wrap(ctx, `${race.name || ""}${race.distance ? ` · ${race.distance}m` : ""}`, 72, 480, W - 144, 40, 1);
  let y = 580;
  const sels = race.analysis.selections.slice(0, 4);
  const silks = await loadSilks(sels.map((s) => race.runners?.find((x) => x.number === s.number)?.silk_url));
  sels.forEach((s, i) => {
    ctx.fillStyle = i === 0 ? "#fbbf24" : "#2563eb";
    ctx.beginPath(); ctx.arc(110, y - 14, 34, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = i === 0 ? "#0B101D" : "#ffffff"; ctx.font = "800 34px 'JetBrains Mono', monospace"; ctx.textAlign = "center";
    ctx.fillText(String(i + 1), 110, y - 2); ctx.textAlign = "left";
    drawSilk(ctx, silks[i], 164, y - 48, 68);
    ctx.fillStyle = "#ffffff"; ctx.font = "800 48px Outfit, sans-serif"; ctx.fillText(fit(ctx, `${s.number}. ${s.horse}`, W - 330), 252, y);
    ctx.fillStyle = "#cbd5e1"; ctx.font = "400 26px 'DM Sans', sans-serif";
    y = s.note ? wrap(ctx, s.note, 252, y + 40, W - 330, 32, 1) + 40 : y + 100;
  });
  return finishCanvas(c, ctx);
}

export const ShareTipCard = ({ meeting, race }) => (
  <ShareButtons make={() => drawCard({ meeting, race })}
    fileName={`weekend-edge-${meeting.track.toLowerCase().replace(/\s+/g, "-")}-r${race.number}.png`}
    title={`${meeting.track} R${race.number} tips`} text={`The Weekend Edge tips: ${meeting.track} R${race.number}`}
    pageUrl={`${window.location.origin}/meeting/${meeting.id}?race=${race.number}`} />
);
